var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"goodslistpage"},[_c('div',{staticClass:"contents"},[_c('goods-list-title',{attrs:{"classname":_vm.classname}}),_vm._v(" "),_c('div',[_c('goods-list-left',{ref:"goodswhere"}),_vm._v(" "),_c('goods-list-right',{on:{"getGoodsWhere":_vm.getGoodsWhere}}),_vm._v(" "),_c('div',{staticClass:"clear"})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae91e42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods/list.vue
// module id = null
// module chunks = 